import React from 'react'
import * as R from 'remeda'

import { SegmentRouteArrow } from '~/components/features/SegmentRouteArrow'
import { type CustomerStrategySegmentRoute } from '~/gql/graphql'

import styles from './Arrows.css'
import {
  cellHeight,
  cellWidth,
  computeArrowPaths,
  gap,
  type Position,
} from './utils'

type ArrowParam = {
  position: Position
  segmentRoute: CustomerStrategySegmentRoute
}

const allArrowParams: ArrowParam[] = [
  {
    position: 'upper',
    segmentRoute: { fromSegmentNumber: 9, toSegmentNumber: 3 },
  },
  {
    position: 'lower',
    segmentRoute: { fromSegmentNumber: 9, toSegmentNumber: 7 },
  },
  {
    position: 'lower',
    segmentRoute: { fromSegmentNumber: 7, toSegmentNumber: 3 },
  },
  {
    position: 'center',
    segmentRoute: { fromSegmentNumber: 5, toSegmentNumber: 3 },
  },
  {
    position: 'lower',
    segmentRoute: { fromSegmentNumber: 3, toSegmentNumber: 1 },
  },
  {
    position: 'lower',
    segmentRoute: { fromSegmentNumber: 8, toSegmentNumber: 7 },
  },
  {
    position: 'upper',
    segmentRoute: { fromSegmentNumber: 8, toSegmentNumber: 3 },
  },
  {
    position: 'lower',
    segmentRoute: { fromSegmentNumber: 6, toSegmentNumber: 5 },
  },
  {
    position: 'lower',
    segmentRoute: { fromSegmentNumber: 6, toSegmentNumber: 3 },
  },
  {
    position: 'lower',
    segmentRoute: { fromSegmentNumber: 4, toSegmentNumber: 3 },
  },
  {
    position: 'lower',
    segmentRoute: { fromSegmentNumber: 4, toSegmentNumber: 1 },
  },
  {
    position: 'lower',
    segmentRoute: { fromSegmentNumber: 2, toSegmentNumber: 1 },
  },
]

export const nineSegmentArrowRoutes: ReadonlyArray<CustomerStrategySegmentRoute> =
  allArrowParams.map((param) => param.segmentRoute)

export type ArrowsProps = {
  selectedRoute: CustomerStrategySegmentRoute | null
  onRouteChange: (route: CustomerStrategySegmentRoute | null) => void
}

export const Arrows = ({ onRouteChange, selectedRoute }: ArrowsProps) => {
  const handleClick = React.useCallback(
    (segmentRoute: CustomerStrategySegmentRoute) => {
      onRouteChange(segmentRoute)
    },
    [onRouteChange],
  )

  return (
    <svg
      className={styles.root}
      height={cellHeight * 2 + gap}
      stroke="var(--colorFontLighter)"
      strokeOpacity={0}
      strokeWidth={12}
      viewBox={`0 0 ${(cellWidth + gap) * 5 - gap} ${
        (cellHeight + gap) * 2 - gap
      }`}
      width={cellWidth * 5 + gap * 4}
    >
      {allArrowParams.map(({ position, segmentRoute }) => {
        const isActive = R.isDeepEqual(selectedRoute, segmentRoute)
        const paths = computeArrowPaths(position, segmentRoute)

        return (
          <SegmentRouteArrow
            key={`${segmentRoute.fromSegmentNumber}-${segmentRoute.toSegmentNumber}`}
            isActive={isActive}
            isInActive={selectedRoute !== null && !isActive}
            paths={paths}
            onClick={() => handleClick(segmentRoute)}
          />
        )
      })}
    </svg>
  )
}
